import { Passagem } from "./interfaces";

export function normalizePassagem(passagem: Passagem): Passagem {
  const adapter = (passagem.adaptador || "").toUpperCase();
  const isWebviagem = adapter === "WEBVIAGEM" || adapter === "GP-API";

  return {
    ...passagem,
    grupo: passagem.grupo ?? "",
    conexoes: passagem.conexoes ?? [],
    classe: passagem.classe && passagem.classe.trim() !== "" ? passagem.classe : "CONVENCIONAL",
    provedorWebviagem: isWebviagem ? (passagem.provedorWebviagem ?? null) : null,
  };
}
